// extracted by mini-css-extract-plugin
export default {"link":"kuTaGy","root":"R6ex7N","label":"M3I7Z2"};